import { createFileRoute, redirect } from '@tanstack/react-router';

import { currentCohort } from '@/cohort-content';
import { ThankYou } from '@/features/registration';

export const Route = createFileRoute('/$hci_shortname/thank-you')({
	beforeLoad: async () => {
		if (!currentCohort) {
			throw redirect({
				to: '/oops',
			});
		}
	},
	component: () => <ThankYou cohort={currentCohort} />,
	head: () => ({
		meta: [
			{
				title: `Thank you | ${currentCohort.name}`,
			},
		],
	}),
});
